import { Dialog } from "primereact/dialog"
import { OrderDocsPayload, OrderDocsResponseData } from "../../../api/types/order"
import styles from "./styles.module.css"
import { useContext, useEffect, useState } from "react"
import userContext from "../../../context/user"
import { useOrderDocuments } from "../../../api/queries/useOrderDocuments"

export const OrderDocumentsModal = ({ orders, onHide }: Props) => {
  const orderDocuments = useOrderDocuments()
  const { user } = useContext(userContext)
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [isPaperVisible, setIsPaperVisible] = useState<boolean>(false)
  const [printPos, setPrintPos] = useState<null | 1 | 2 | 3 | 4 | undefined>(undefined)
  const [docs, setDocs] = useState<OrderDocsResponseData | null>(null)

  const onHideInner = () => {
    setIsVisible(false)
    setIsPaperVisible(false)
    setPrintPos(undefined)
    setDocs(null)

    orderDocuments.reset()

    onHide()
  }

  const onPositionSelect = async (position: 1 | 2 | 3 | 4) => {
    setIsPaperVisible(false)
    setPrintPos(position)
  }

  const header = (
    <span className={"mr-3"}>Dokumenty ke stažení</span>
  )

  // get docs
  useEffect(() => {
    if (
      orders &&
      printPos !== undefined &&
      !orderDocuments.isLoading &&
      !orderDocuments.isSuccess &&
      !docs
    ) {
      const getData = async () => {
        const payload: OrderDocsPayload = {
          orders,
          A4PrintStartPosition: printPos,
          sendEmail: true,
        }

        const data = await orderDocuments.mutateAsync(payload)
        setDocs(data)
      }

      getData()
    }
  }, [printPos, orders, orderDocuments, docs])

  // determine if paper should be visible
  useEffect(() => {
    if (isVisible) {
      if (user?.labelFormat === "A4") {
        setIsPaperVisible(true)
      } else {
        setPrintPos(null) // A6 === null
      }
    }
  }, [isVisible, user?.labelFormat])

  // show modal
  useEffect(() => {
    if (orders !== null) {
      setIsVisible(true)
    }
  }, [orders, orderDocuments])

  return (
    <Dialog visible={isVisible} onHide={onHideInner} header={header} draggable={false}
      closable={!isPaperVisible}>
      {isPaperVisible ? (
        <>
          <div className={"mb-3"}>Vyberte počáteční pozici tisku:</div>
          <div className={styles.paper}>
            <div className={styles.position} onClick={() => onPositionSelect(1)}>1</div>
            <div className={styles.position} onClick={() => onPositionSelect(2)}>2</div>
            <div className={styles.position} onClick={() => onPositionSelect(3)}>3</div>
            <div className={styles.position} onClick={() => onPositionSelect(4)}>4</div>
          </div>
        </>
      ) : (
        <>
          {!docs && (
            <div className={"text-center"}>
              <i className={"pi pi-spin pi-spinner"} style={{ fontSize: "2rem" }} />
            </div>
          )}

          {docs?.results.label && (
            <div className={"my-1"}>
              <i className={"pi pi-file-pdf"} />{" "}
              <a href={docs.results.label} download={true} target={"_blank"} rel={"noreferrer"}
                className={"text-primary no-underline"}>Štítek</a>
            </div>
          )}
          {docs?.results.list && (
            <div className={"my-1"}>
              <i className={"pi pi-file-pdf"} />{" "}
              <a href={docs.results.list} download={true} target={"_blank"} rel={"noreferrer"}
                className={"text-primary no-underline"}>Soupiska</a>
            </div>
          )}
        </>
      )}
    </Dialog>
  )
}

interface Props {
  orders: string[] | null;
  onHide: () => void;
}
